import { render, staticRenderFns } from "./taxdifimp.vue?vue&type=template&id=14d73fc8&scoped=true&"
import script from "./taxdifimp.vue?vue&type=script&lang=js&"
export * from "./taxdifimp.vue?vue&type=script&lang=js&"
import style0 from "./taxdifimp.vue?vue&type=style&index=0&id=14d73fc8&lang=scss&scoped=true&"
import style1 from "./taxdifimp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d73fc8",
  null
  
)

export default component.exports